import { render, staticRenderFns } from "./SomeHelpfulTips.vue?vue&type=template&id=236d24b2&scoped=true&"
import script from "./SomeHelpfulTips.vue?vue&type=script&lang=js&"
export * from "./SomeHelpfulTips.vue?vue&type=script&lang=js&"
import style0 from "./SomeHelpfulTips.vue?vue&type=style&index=0&id=236d24b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236d24b2",
  null
  
)

export default component.exports